import React, {memo} from 'react';
import {ActivityIndicator, Pressable, TouchableOpacity, View} from 'react-native';

import { StyleSheet } from 'react-native';
import {colorPalette, colors} from '../../../core/config/color.config';

import {RNEText, RNEInput, RNEButton, SVGIcon} from '../../components';
import { Text } from 'react-native';
import {width, height, totalSize} from 'react-native-dimension';

interface AdminSearchHeaderProps {
  title: string;
  placeholder?: string;
  searchValue?: string;
  showFilter?: boolean;
  onSearchValueChange?: (val: string) => void;
  onFilterClick?: () => void;
  onExportClick?: () => void;
  isExportBtnVisible?: boolean;
  isExportLoading?: boolean;
}

const AdminSearchHeader = (props: AdminSearchHeaderProps) => {

  const {title = '', placeholder = 'Search', showFilter = true, isExportBtnVisible = false, onExportClick, isExportLoading=false} = props;

  const onSearchChange = (val: string) => {
    props.onSearchValueChange?.(val);
  };

  return (
    <View style={styles.rootContainer}>
      <View style={styles.titleContainer}>
        <RNEText
          label={title}
          color="accent"
          variant="subheader"
          weight="600"
          style={{fontFamily:'Quicksand-SemiBold'}}
        />
      </View>

      <View style={styles.rightGroupContainer}>

        <View>
          <RNEInput
            leftIcon={<SVGIcon name="search" size={24} />}
            placeholder={placeholder}
            value={props.searchValue}
            onChangeText={onSearchChange}
          />
        </View>

        {
          isExportBtnVisible && !isExportLoading && (
            <View style={{marginLeft: width(2)}}>
              <Pressable onPress={onExportClick} style={{flexDirection: 'row' , gap: width(0.5), justifyContent:'center', alignContent:'center',alignItems:'center'}}>
                <SVGIcon name="download-down" size={totalSize(1.5)} />
                <Text style={{fontSize: totalSize(0.8), fontFamily:'Quicksand-SemiBold', marginTop: height(0.5), color: colors.gray.regular}}>Export</Text>
              </Pressable>
            </View>
          )
        }

        {isExportBtnVisible && isExportLoading && (
          <View style={{marginLeft: width(2)}}>
            <ActivityIndicator size="small" color={colorPalette.primary} style={{ marginVertical: width(1) }} />
          </View>
        )}

        {/* <View style={styles.actionContainer}>
          {showFilter && (
            <View style={styles.action}>
              <RNEButton
                title="Filter"
                type="clear"
                icon={<SVGIcon name="menu-light-blue" />}
                titleStyle={actionTitleStyle}
              />
            </View>
          )}

          <View style={styles.action}>
            <RNEButton
              title="Export"
              type="clear"
              icon={<SVGIcon name="download-down" />}
              titleStyle={actionTitleStyle}
            />
          </View>
        </View> */}
      </View>
    </View>
  );
};

const actionTitleStyle = {
  color: colorPalette.black,
  marginLeft: 12,
};

const styles = StyleSheet.create({
  rootContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  titleContainer: {
    flexDirection: 'row',
    flex: 1,
    flexWrap: 'wrap',
  },
  rightGroupContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  searchContainer: {
    width: 350,
  },
  actionContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  action: {
    marginLeft: 24,
  },
});

export default memo(AdminSearchHeader);
